<div class="page">
    <div class="myProject-div">
        <div class="myProject-img">
            <a [routerLink]="['/user/projects']"> <img src="../../../assets/homepage-images/project.png" alt="img"/> </a>
        </div>
    </div>
    <app-new-homepage-landing></app-new-homepage-landing>
</div>

